export class FotobiometriaDisponibilidadeModel {
  id?: number;
  horario?: string;
  codigoTurma?: string;
  quantidadeVagas?: number;
  localId?: number;
  dataCadastro?: any;
  usuarioCadastro?: string;
  dataAlteracao?: any;
  usuarioAlteracao?: string;
  situacao?: number;
  ativo?: boolean;
  local?: Local;
  quantidadeVagasMarcadas?: number;
  quantidadeVagasDisponiveis?: number;
  dataFim?: any;

  constructor(
    options: FotobiometriaDisponibilidadeModel = {}
  ) {
    this.id = options.id || null;
    this.horario = options.horario || null;
    this.codigoTurma = options.codigoTurma || null;
    this.quantidadeVagas = options.quantidadeVagas || null;
    this.localId = options.localId || null;
    this.dataCadastro = options.dataCadastro || null;
    this.usuarioCadastro = options.usuarioCadastro || null;
    this.dataAlteracao = options.dataAlteracao || null;
    this.usuarioAlteracao = options.usuarioAlteracao || null;
    this.situacao = options.situacao || null;
    this.ativo = options.ativo || null;
    this.local = options.local || null;
    this.quantidadeVagasMarcadas = options.quantidadeVagasMarcadas || null;
    this.quantidadeVagasDisponiveis = options.quantidadeVagasDisponiveis || null;
    this.dataFim = options.dataFim || null;
  }
}

interface Local {
  id?: number;
  descricao?: string
}
